import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.781 22.701L20.56 16.8c-1-.576-2.25.144-2.25 1.298v11.806c0 1.154 1.25 1.874 2.25 1.298L30.781 25.3a1.5 1.5 0 000-2.598z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5a4.5 4.5 0 004.5-4.5V15a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 15v18A4.5 4.5 0 009 37.5h30z",
    clipRule: "evenodd"
  }))
};
export var VideoPlayer = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});